module.exports = __webpack_public_path__ + "static/media/loader.434248d2.gif";